import { z } from "zod";

export const doubleAuthentificationSchema = z.object({
  token: z.string().refine((val) => val.length === 6),
  emailOrConnectId: z.string(),
  password: z.string(),
});

export const defaultDoubleAuthentificationValues = {
  token: "",
  emailOrConnectId: "",
  password: "",
};

export type DoubleAuthentificationForm = z.infer<
  typeof doubleAuthentificationSchema
>;
